export function isBlank(str: string): boolean {
  return /^\s*$/.test(str == null ? '' : str);
}

export function isEmpty(str: string | number): boolean {
  return str === undefined || str === null || str === '';
}

export function isNotEmpty(str: string | number): boolean {
  return !isEmpty(str);
}
